<div class="title title_center">
    <a class="returnIcon" (click)="returnCondition()">
        <img src="assets/img/arrow-right.svg"  alt="">
    </a>
    <h1 *ngIf="!appVersion" class="header1">{{title}}</h1>
    <h1 *ngIf="appVersion" class="header1">{{title}} <span style="font-family: 'novin_regular'; font-size: 18px;">( نسخه <i> {{appVersion}} </i>)</span></h1>

</div>
